import { createRouter, createMemoryHistory, RouteLocationRaw } from 'vue-router';
import { AmplitudeService } from '@/services';
import { Routes } from './routes';

const amplitude = new AmplitudeService();

const routesConfig = [
	{
		path: Routes.CUSTOMIZE_DEAL.path,
		name: Routes.CUSTOMIZE_DEAL.name,
		component: async () => {
			const { CustomizeDealView } = await import(/* webpackChunkName: "customize-deal" */ '@/components/views/customize-deal');

			return CustomizeDealView;
		},
		meta: { Level: 1, Feature: 'CustomizeDeal', Description: 'Customize deal page.' },
	},
	{
		path: Routes.TRADE_IN.path,
		name: Routes.TRADE_IN.name,
		component: async () => {
			const { TradeInContainerView } = await import(/* webpackChunkName: "trade-in" */ '@/components/views/trade-in/select-vehicle');

			return TradeInContainerView;
		},
		meta: { Level: 1, Feature: 'TradeIn', Description: 'Search vehicle page.' },
	},
	{
		path: Routes.TRADE_IN_CONDITION.path,
		name: Routes.TRADE_IN_CONDITION.name,
		component: async () => {
			const { VehicleConditionView } = await import(/* webpackChunkName: "trade-in" */ '@/components/views/trade-in/vehicle-condition-container');

			return VehicleConditionView;
		},
		meta: { Level: 2, Feature: 'TradeIn', Description: 'Question page.' },
	},
	{
		path: Routes.TRADE_IN_OVERVIEW.path,
		name: Routes.TRADE_IN_OVERVIEW.name,
		component: async () => {
			const { VehicleOverviewView } = await import(/* webpackChunkName: "trade-in" */ '@/components/views/trade-in/vehicle-overview-container');

			return VehicleOverviewView;
		},
		meta: { Level: 3, Feature: 'TradeIn', Description: 'Overview page.' },
	},
	{
		path: Routes.CREDIT_SCORE.path,
		name: Routes.CREDIT_SCORE.name,
		component: async () => {
			const { CreditScoreView } = await import(/* webpackChunkName: "credit-score" */ '@/components/views/credit-score');

			return CreditScoreView;
		},
		meta: { Level: 1, Feature: 'CreditScore', Description: 'Credit Score Form.' },
	},
	{
		path: Routes.CREDIT_SCORE_SUCCESS.path,
		name: Routes.CREDIT_SCORE_SUCCESS.name,
		component: async () => {
			const { CbcApplicationSuccess } = await import(/* webpackChunkName: "credit-score" */ '@/components/views/credit-score/components/cbc-application-success/component');

			return CbcApplicationSuccess;
		},
		meta: { Level: 2, Feature: 'CreditScore', Description: 'Credit Score Success Page.' },
	},
	{
		path: Routes.CREDIT_APPLICATION_SUCCESS.path,
		name: Routes.CREDIT_APPLICATION_SUCCESS.name,
		component: async () => {
			const { CreditApplicationSuccess } = await import(/* webpackChunkName: "credit-score" */ '@/components/views/credit-application/components/credit-application-success');

			return CreditApplicationSuccess;
		},
		meta: { Level: 2, Feature: 'CreditApplication', Description: 'Credit Application Success Page.' },
	},
	{
		path: Routes.CREDIT_APPLICATION.path,
		name: Routes.CREDIT_APPLICATION.name,
		component: async () => {
			const { CreditApplicationView } = await import(/* webpackChunkName: "credit-score" */ '@/components/views/credit-application');

			return CreditApplicationView;
		},
		meta: { Level: 1, Feature: 'CreditApplication', Description: 'Credit Application Form.' },
	},
	{
		path: Routes.ERROR.path,
		name: Routes.ERROR.name,
		component: async () => {
			const { ErrorView } = await import(/* webpackChunkName: "error" */ '@/components/views/error');

			return ErrorView;
		},
		meta: { Level: 1, Feature: 'Error', Description: 'Error page.' },
	},
	{
		path: Routes.BLANK.path,
		name: Routes.BLANK.name,
		component: async () => {
			const { BlankView } = await import(/* webpackChunkName: "blank" */ '@/components/views/blank');

			return BlankView;
		},
		meta: { Level: 1, Feature: 'Blank', Description: 'Blank page.' },
	},
	{
		path: Routes.DEV.path,
		name: Routes.DEV.name,
		component: async () => {
			const { DevView } = await import(/* webpackChunkName: "dev" */ '@/components/views/dev');

			return DevView;
		},
		meta: { Level: 1, Feature: 'Dev', Description: 'Dev page.' },
	},
	{
		path: Routes.OPTIONS.path,
		name: Routes.OPTIONS.name,
		component: async () => {
			const { OptionsView } = await import(/* webpackChunkName: "options" */ '@/components/views/protections-and-options/');

			return OptionsView;
		},
		meta: { Level: 1, Feature: 'ProtectionsAndOptions', Description: 'Option view page.' },
	},
	{
		path: Routes.OPTION_DETAILS.path,
		name: Routes.OPTION_DETAILS.name,
		component: async () => {
			const { OptionDetailsView } = await import(/* webpackChunkName: "option-details" */ '@/components/views/protections-and-options/details/');

			return OptionDetailsView;
		},
		meta: { Level: 2, Feature: 'ProtectionsAndOptions', Description: 'Option detail page.' },
	},
	{
		path: Routes.SAVE_MY_DEAL_SUCCESS.path,
		name: Routes.SAVE_MY_DEAL_SUCCESS.name,
		component: async () => {
			const { SaveMyDealSuccessView } = await import(/* webpackChunkName: "save-my-deal" */ '@/components/views/save-my-deal/success');

			return SaveMyDealSuccessView;
		},
		meta: { Level: 1, Feature: 'SaveMyDeal', Description: 'SaveMyDealSuccess page.' },
	},
	{
		path: Routes.SAVE_MY_DEAL_FORM.path,
		name: Routes.SAVE_MY_DEAL_FORM.name,
		component: async () => {
			const { SaveMyDealFormView } = await import(/* webpackChunkName: "save-my-deal" */ '@/components/views/save-my-deal/form');

			return SaveMyDealFormView;
		},
		meta: { Level: 1, Feature: 'SaveMyDeal', Description: 'SaveMyDealForm page.' },
	},
	{
		path: Routes.REBATES.path,
		name: Routes.REBATES.name,
		component: async () => {
			const { RebatesView } = await import(/* webpackChunkName: "rebates" */ '@/components/views/rebates/rebates');

			return RebatesView;
		},
		meta: { Level: 1, Feature: 'Rebates', Description: 'Rebates page.' },
	},
	{
		path: Routes.REBATES_SETTINGS.path,
		name: Routes.REBATES_SETTINGS.name,
		component: async () => {
			const { RebatesSettingsView } = await import(/* webpackChunkName: "rebates" */ '@/components/views/rebates/settings');

			return RebatesSettingsView;
		},
		meta: { Level: 1, Feature: 'Rebates', Description: 'Rebates Settings page.' },
	},
	{
		path: Routes.REBATES_DETAILS.path,
		name: Routes.REBATES_DETAILS.name,
		component: async () => {
			const { RebatesDetailsView } = await import(/* webpackChunkName: "rebates" */ '@/components/views/rebates/details');

			return RebatesDetailsView;
		},
		meta: { Level: 1, Feature: 'Rebates', Description: 'Rebates Details page.' },
	},
	{
		path: Routes.DEAL_PROGRESS.path,
		name: Routes.DEAL_PROGRESS.name,
		component: async () => {
			const { DealProgressContainer } = await import(/* webpackChunkName: "deal-progress" */ '@/components/views/deal-progress/components/deal-progress-container');

			return DealProgressContainer;
		},
		meta: { Level: 1, Feature: 'DealProgress', Description: 'Deal Progress page.' },
	},
	{
		path: Routes.RESERVE_VEHICLE_OVERVIEW.path,
		name: Routes.RESERVE_VEHICLE_OVERVIEW.name,
		component: async () => {
			const { ReserveVehicleOverviewView } = await import(/* webpackChunkName: "reserve-vehicle" */ '@/components/views/reserve-vehicle/overview');

			return ReserveVehicleOverviewView;
		},
		meta: { Level: 1, Feature: 'ReserveVehicle', Description: 'Reserve Vehicle Overview page.' },
	},
	{
		path: Routes.RESERVED_VEHICLE_INFO.path,
		name: Routes.RESERVED_VEHICLE_INFO.name,
		component: async () => {
			const { ReservedVehicleInfoView } = await import(/* webpackChunkName: "reserve-vehicle" */ '@/components/views/reserve-vehicle/reserved');

			return ReservedVehicleInfoView;
		},
		meta: { Level: 1, Feature: 'ReserveVehicle', Description: 'Reserve Vehicle Info page.' },
	},
	{
		path: Routes.RESERVE_VEHICLE_FORM.path,
		name: Routes.RESERVE_VEHICLE_FORM.name,
		component: async () => {
			const { ReserveVehicleFormView } = await import(/* webpackChunkName: "reserve-vehicle" */ '@/components/views/reserve-vehicle/form');

			return ReserveVehicleFormView;
		},
		meta: { Level: 1, Feature: 'ReserveVehicle', Description: 'Reserve Vehicle Form page.' },
	},
	{
		path: Routes.RESERVE_VEHICLE_PAYMENT_RESPONSE.path,
		name: Routes.RESERVE_VEHICLE_PAYMENT_RESPONSE.name,
		component: async () => {
			const { ReserveVehicleResponseView } = await import(/* webpackChunkName: "reserve-vehicle" */ '@/components/views/reserve-vehicle/response');

			return ReserveVehicleResponseView;
		},
		meta: { Level: 1, Feature: 'ReserveVehicle', Description: 'Reserve Vehicle Payment Response page.' },
	},
	{
		path: Routes.DEAL_DETAILS.path,
		name: Routes.DEAL_DETAILS.name,
		component: async () => {
			const { DealDetailsView } = await import(/* webpackChunkName: "deal-details" */ '@/components/views/deal-details');

			return DealDetailsView;
		},
		meta: { Level: 1, Feature: 'DealDetails', Description: 'Deal Details page.' },
	},
	{
		path: Routes.ZIPCODE.path,
		name: Routes.ZIPCODE.name,
		component: async () => {
			const { ZipCodeView } = await import(/* webpackChunkName: "zipcode" */ '@/components/views/zip-code');

			return ZipCodeView;
		},
		meta: { Level: 1, Feature: 'Zipcode', Description: 'Zipcode page.' },
	},
	{
		path: Routes.SCHEDULE_TEST_DRIVE.path,
		name: Routes.SCHEDULE_TEST_DRIVE.name,
		component: async () => {
			const { ScheduleTestDriveView } = await import(/* webpackChunkName: "schedule-test-drive" */ '@/components/views/schedule-test-drive');

			return ScheduleTestDriveView;
		},
		meta: { Level: 1, Feature: 'ScheduleTestDrive', Description: 'Schedule Test Drive page.' },
	},
	{
		path: Routes.SCHEDULE_TEST_DRIVE_CONTACT.path,
		name: Routes.SCHEDULE_TEST_DRIVE_CONTACT.name,
		component: async () => {
			const { ScheduleTestDriveContactView } = await import(/* webpackChunkName: "schedule-test-drive" */ '@/components/views/schedule-test-drive/contact');

			return ScheduleTestDriveContactView;
		},
		meta: { Level: 2, Feature: 'ScheduleTestDrive', Description: 'Schedule Test Drive Contact page.' },
	},
	{
		path: Routes.SCHEDULE_TEST_DRIVE_SUCCESS.path,
		name: Routes.SCHEDULE_TEST_DRIVE_SUCCESS.name,
		component: async () => {
			const { ScheduleTestDriveSuccessView } = await import(/* webpackChunkName: "schedule-test-drive" */ '@/components/views/schedule-test-drive/success');

			return ScheduleTestDriveSuccessView;
		},
		meta: { Level: 3, Feature: 'ScheduleTestDrive', Description: 'Schedule Test Drive Success page.' },
	},
	{
		path: Routes.ACCESSORIES.path,
		name: Routes.ACCESSORIES.name,
		component: async () => {
			const { AccessoriesView } = await import(/* webpackChunkName: "accessories" */ '@/components/views/accessories/list');

			return AccessoriesView;
		},
		meta: { Level: 1, Feature: 'Accessories', Description: 'Accessories List Page.' },
	},
	{
		path: Routes.ACCESSORIES_DETAILS.path,
		name: Routes.ACCESSORIES_DETAILS.name,
		component: async () => {
			const { AccessoriesDetails } = await import(/* webpackChunkName: "accessories" */ '@/components/views/accessories/details');

			return AccessoriesDetails;
		},
		meta: { Level: 2, Feature: 'Accessories', Description: 'Accessories Details Page.' },
	},
	{
		path: Routes.CONTACT_US.path,
		name: Routes.CONTACT_US.name,
		component: async () => {
			const { ContactUsView } = await import(/* webpackChunkName: "contact-us" */ '@/components/views/contact-us');

			return ContactUsView;
		},
	},
	{
		path: Routes.DEALER_DISCOUNT_FORM.path,
		name: Routes.DEALER_DISCOUNT_FORM.name,
		component: async () => {
			const { DealerDiscountFormView } = await import(/* webpackChunkName: "dealer-discount" */ '@/components/views/dealer-discount/form');

			return DealerDiscountFormView;
		},
		meta: { Level: 1, Feature: 'DealerDiscount', Description: 'DealerDiscount Form page.' },
	},
	{
		path: Routes.DEALER_DISCOUNT_SUCCESS.path,
		name: Routes.DEALER_DISCOUNT_SUCCESS.name,
		component: async () => {
			const { DealerDiscountSuccessView } = await import(/* webpackChunkName: "dealer-discount" */ '@/components/views/dealer-discount/success');

			return DealerDiscountSuccessView;
		},
		meta: { Level: 1, Feature: 'DealerDiscount', Description: 'DealerDiscount Success page.' },
	},
];

const router = createRouter({
	history: createMemoryHistory(),
	routes: routesConfig,
});

router.originalPush = router.push;
router.afterEach(() => {
	amplitude.sendNavigationEventWithTimestamp(router.currentRoute.value.meta);
});
router.push = async function push(location: RouteLocationRaw | string) {
	if (location === this.currentRoute.value.path) {
		return this.currentRoute;
	}
	return this.originalPush(location);
};

export { router };
